import { PermissionType } from './PermissionType'

export enum PermissionSetGroupingKey {
  AccessGrant = 'AccessGrant',
  AdminUser = 'AdminUser',
  AiAgent = 'AiAgent',
  Ai = 'Ai',
  Analytics = 'Analytics',
  AnalyticsTemplateLibrary = 'AnalyticsTemplateLibrary',
  Announcement = 'Announcement',
  ApiKey = 'ApiKey',
  App = 'App',
  AuditLog = 'AuditLog',
  AuthorizationGroup = 'AuthorizationGroup',
  AuthorizationGroupMembership = 'AuthorizationGroupMembership',
  AuthorizationRole = 'AuthorizationRole',
  BulkMessage = 'BulkMessage',
  CancellationReason = 'CancellationReason',
  DriverBreakReason = 'DriverBreakReason',
  QuickReply = 'QuickReply',
  Case = 'Case',
  CaseType = 'CaseType',
  Charge = 'Charge',
  Comment = 'Comment',
  ConnectedAccount = 'ConnectedAccount',
  CustomLink = 'CustomLink',
  DataRetentionSchedule = 'DataRetentionSchedule',
  Device = 'Device',
  DirectorySync = 'DirectorySync',
  Driver = 'Driver',
  DriverUser = 'DriverUser',
  Duty = 'Duty',
  DutyDelay = 'DutyDelay',
  DutyRequestOffer = 'DutyRequestOffer',
  DriverBreak = 'DriverBreak',
  EdiBrokerConfiguration = 'EdiBrokerConfiguration',
  EdiEligibilityCheck = 'EdiEligibilityCheck',
  EngageReporting = 'EngageReporting',
  Event = 'Event',
  FarePass = 'FarePass',
  FareRule = 'FareRule',
  FavoriteLocation = 'FavoriteLocation',
  FixedRouteForDisplay = 'FixedRouteForDisplay',
  Fleet = 'Fleet',
  Form = 'Form',
  Gtfs = 'Gtfs',
  GtfsRealtime = 'GtfsRealtime',
  Group = 'Group',
  Ivr = 'Ivr',
  Journey = 'Journey',
  KnowledgeEntry = 'KnowledgeEntry',
  LaunchReporting = 'LaunchReporting',
  Letter = 'Letter',
  NotificationDeliveryPolicy = 'NotificationDeliveryPolicy',
  NotificationSetting = 'NotificationSetting',
  NylasAdminGrant = 'NylasAdminGrant',
  MatchingOutcome = 'MatchingOutcome',
  OperationalAlerts = 'OperationalAlerts',
  Provider = 'Provider',
  Organization = 'Organization',
  PaymentMethod = 'PaymentMethod',
  PaymentMethodType = 'PaymentMethodType',
  PhoneNumber = 'PhoneNumber',
  Platform = 'Platform',
  Promo = 'Promo',
  Realize = 'Realize',
  ResolveReporting = 'ResolveReporting',
  Request = 'Request',
  Review = 'Review',
  Rider = 'Rider',
  RiderDriverRestriction = 'RiderDriverRestriction',
  RiderRiderRestriction = 'RiderRiderRestriction',
  RiderOnboardingFlow = 'RiderOnboardingFlow',
  RiderVehicleTypeRestriction = 'RiderVehicleTypeRestriction',
  RiderRepresentative = 'RiderRepresentative',
  RiderUser = 'RiderUser',
  Service = 'Service',
  Simulation = 'Simulation',
  Ticket = 'Ticket',
  TimeRule = 'TimeRule',
  Tip = 'Tip',
  TripGroup = 'TripGroup',
  UserBan = 'UserBan',
  UserFleetAgreement = 'UserFleetAgreement',
  UserOwn = 'UserOwn',
  Vehicle = 'Vehicle',
  VehicleType = 'VehicleType',
  Webhook = 'Webhook',
  Workflow = 'Workflow',
  EamAsset = 'EamAsset',
  EamContact = 'EamContact',
  EamEnergyEntry = 'EamEnergyEntry',
  EamMeterEntry = 'EamMeterEntry',
  EamServiceTask = 'EamServiceTask',
  EamServiceProgram = 'EamServiceProgram',
  EamServiceSchedule = 'EamServiceSchedule',
  EamServiceScheduleTask = 'EamServiceScheduleTask',
  EamServiceReminder = 'EamServiceReminder',
  EamWorkOrder = 'EamWorkOrder',
  EamServiceEntry = 'EamServiceEntry',
  EamPart = 'EamPart',
  EamIssue = 'EamIssue',
  EamInventory = 'EamInventory',
  EamLocation = 'EamLocation',
  EamPurchaseOrder = 'EamPurchaseOrder',
  EamVendor = 'EamVendor',
  EamInspectionForm = 'EamInspectionForm',
  EamInspection = 'EamInspection',
  EamSetting = 'EamSetting',
  SidebarProductVisibility = 'SidebarProductVisibility',
  SuperAdminDefault = 'SuperAdminDefault',
  SuperAdminEngineeringLead = 'SuperAdminEngineeringLead',
  SuperAdminSiteReliabilityEngineer = 'SuperAdminSiteReliabilityEngineer',
  SuperAdminPartnerSuccess = 'SuperAdminPartnerSuccess',
  SuperAdminTestRole = 'SuperAdminTestRole',
  SuperAdminRoot = 'SuperAdminRoot',
}

export interface IPermissionSetGrouping<T extends string> {
  key: PermissionSetGroupingKey
  active: Record<T, PermissionType[]>

  /**
   * Determines which permission sets are hidden from the UI and cannot be assigned to users.
   * An example of un-assignable permission set is the `driver` or `rider` permission sets
   */
  unAssignablePermissionSets: T[]

  /**
   * Determines if the SuperAdmin permission set is set.
   * Defaults to undefined to be false.
   */
  isSuperAdminSet?: boolean
}
